var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-container"},[_c('span',{staticClass:"bar-title"},[_vm._v(" "+_vm._s(_vm.title))]),_c('div',{class:_vm.bold ? 'bar-content bold' : 'bar-content'},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }